<template>
  <div class="member-learning">
    <!--面板中的内容-->
    <div class="member-right-inner-bottom">
      <!--如果需要使用收起全部的功能,ref必须要写,ref不要使用同一个，ref设置在Pen组件-->
      <div style="clear: both;">
        <button class="btn-close-all" @click="closeAll">
          {{ allCloseAble ? "收起全部" : "展开全部" }}
        </button>
      </div>

      <!--      标签,类似笔的形状,如果需要使用收起全部的功能,ref必须要写,ref不要使用同一个-->
      <Education
        :eduCloseAble="eduCloseAble"
        :trueFlag="trueFlag"
        :falseFlag="falseFlag"
        @getTrueFlag="getTrueFlag"
        @getFalseFlag="getFalseFlag"
        @handleSave="handleSave"
        ref="education"
      ></Education>
      <Study
        :studyCloseAble="studyCloseAble"
        :trueFlag="trueFlag"
        :falseFlag="falseFlag"
        @getTrueFlag="getTrueFlag"
        @getFalseFlag="getFalseFlag"
        @handleSave="handleSave"
        ref="study"
      ></Study>
      <Abroad
        :abroadCloseAble="abroadCloseAble"
        :trueFlag="trueFlag"
        :falseFlag="falseFlag"
        @getTrueFlag="getTrueFlag"
        @getFalseFlag="getFalseFlag"
        @handleSave="handleSave"
        ref="abroad"
      ></Abroad>
      <Teacher
        :teacherCloseAble="teacherCloseAble"
        :trueFlag="trueFlag"
        :falseFlag="falseFlag"
        @getTrueFlag="getTrueFlag"
        @getFalseFlag="getFalseFlag"
        @handleSave="handleSave"
        ref="teacher"
      ></Teacher>
    </div>
  </div>
</template>

<script>
import Education from "./learning/Education";
import Study from "./learning/Study";
import Abroad from "./learning/Abroad";
import Teacher from "./learning/Teacher";

export default {
  name: "Learning",
  components: { Teacher, Study, Education, Abroad },
  data() {
    return {
      children: [
        { path: "/privateplot/member/basic", name: "基本信息" },
        { path: "/privateplot/member/learning", name: "学习经历" },
        { path: "/privateplot/member/working", name: "工作经历" },
        { path: "/privateplot/member/certificate", name: "资格证书" },
        {
          path: "/privateplot/member/personalHonoraryTitle",
          name: "个人荣誉称号"
        }
      ],
      editAllFlag: { flag: false },
      editEducationFlag: { flag: false },
      editStudyFlag: { flag: false },

      eduCloseAble: { flag: true },
      studyCloseAble: { flag: true },
      abroadCloseAble: { flag: true },
      teacherCloseAble: { flag: true },
      allCloseAble: true,

      trueFlag: null, //编辑框正在打开的类型标识，null：所有编辑框都是关闭的状态，0：第一个子页面的编辑框打开，1：第二个子页面的编辑框打开...以此类推
      falseFlag: null, // 上一个需要关闭的编辑框的类型标识，null：没有编辑框需要关闭，0：第一个子页面的编辑框需要关闭，1：第二个子页面的编辑框需要关闭...以此类推
      editFlag: null,
      nextFlag: true //判断是否跳转页面
    };
  },

  watch: {
    getChildEditAllFlag(newVal) {
      this.editAllFlag = { flag: newVal };
    },

    allCloseAble(newVal) {
      this.eduCloseAble = { flag: newVal };
      this.studyCloseAble = { flag: newVal };
      this.abroadCloseAble = { flag: newVal };
      this.teacherCloseAble = { flag: newVal };
    }
  },

  mounted() {
    this.editFlag =
      this.$store.state.MemberManageModule.userId == null &&
      !["view", "update"].includes(this.$store.state.MemberManageModule.type)
        ? true
        : false;
    window.onbeforeunload = e => {
      if (this.trueFlag == null) {
        return;
      }
      // 通知浏览器不要执行与事件关联的默认动作
      e.preventDefault();
      // Chrome 需要 returnValue 被设置成空字符串
      e.returnValue = "";
    };
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.onBack, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.onBack, false);
  },
  methods: {
    // 监听返回按钮的处理函数
    onBack() {
      if (this.trueFlag !== null) {
        const h = this.$createElement;
        this.$confirm("提示", {
          message: h("p", null, [
            h(
              "p",
              { style: "font-size: 18px;line-height: 40px;" },
              "有内容没有保存，是否保存并退出编辑？"
            ),
            h(
              "p",
              { style: "font-size: 14px;color: #00000069;" },
              "放弃修改，更新的内容不会自动保存"
            )
          ]),
          distinguishCancelAndClose: true,
          confirmButtonText: "保存",
          cancelButtonText: "放弃修改",
          type: "warning"
        })
          .then(() => {
            this.handleSave();
            // this.trueFlag = null;
            this.$emit("getEditFlag", false);
            if (!this.nextFlag) {
              this.nextFlag = true;
              next(false);
            } else {
              this.$router.go(-1);
            }
          })
          .catch(action => {
            if (action === "cancel") {
              this.trueFlag = null;
              this.$emit("getEditFlag", false);
              this.$router.go(-1);
            } else {
              history.pushState(null, null, document.URL);
            }
          });
      } else {
        this.$router.go(-1);
      }
    },
    getTrueFlag(data) {
      this.trueFlag = data;
      if (data !== null) {
        this.$emit("getEditFlag", true);
      } else {
        this.$emit("getEditFlag", false);
      }
    },

    getFalseFlag(data) {
      this.falseFlag = data;
    },
    handleSave(data, row, index) {
      const save = data !== this.trueFlag ? "1" : "2";
      let i;
      let form;
      if (this.trueFlag === 0) {
        form = this.$refs.education.form;
        i = this.$refs.education.globalIndex;
        this.$refs.education.handleSaveClick(form, i, save);
      } else if (this.trueFlag === 1) {
        form = this.$refs.study.form;
        i = this.$refs.study.globalIndex;
        this.$refs.study.handleSaveClick(form, i, save);
      } else if (this.trueFlag === 2) {
        form = this.$refs.abroad.form;
        i = this.$refs.abroad.globalIndex;
        this.$refs.abroad.handleSaveClick(form, i, save);
      } else if (this.trueFlag === 3) {
        form = this.$refs.teacher.form;
        i = this.$refs.teacher.globalIndex;
        this.$refs.teacher.handleSaveClick(form, i, save);
      }

      if (
        (this.$refs.education.validateFileForm() &&
          !this.$refs.education.validateDate) ||
        (this.$refs.study.validateFileForm() &&
          !this.$refs.study.validateDate) ||
        (this.$refs.abroad.validateFileForm() &&
          !this.$refs.abroad.validateDate) ||
        (this.$refs.teacher.validateFileForm() &&
          !this.$refs.teacher.validateDate)
      ) {
        if (data === 0) {
          this.$refs.education.handleChangeEdit(row, index);
        } else if (data === 1) {
          this.$refs.study.handleChangeEdit(row, index);
        } else if (data === 2) {
          this.$refs.abroad.handleChangeEdit(row, index);
        } else if (data === 3) {
          this.$refs.teacher.handleChangeEdit(row, index);
        }

        this.trueFlag = data;
      } else {
        this.$emit("changeRightMenu");
        this.nextFlag = false;
      }
    },
    //改变所有面板的状态
    closeAll() {
      this.allCloseAble = !this.allCloseAble;
    }
  },

  beforeRouteLeave(to, from, next) {
    const that = this;
    if (this.trueFlag == null) {
      next();
      return;
    }
    const h = this.$createElement;
    this.$confirm("提示", {
      message: h("p", null, [
        h(
          "p",
          { style: "font-size: 18px;line-height: 40px;" },
          "有内容没有保存，是否保存并退出编辑？"
        ),
        h(
          "p",
          { style: "font-size: 14px;color: #00000069;" },
          "放弃修改，更新的内容不会自动保存"
        )
      ]),
      distinguishCancelAndClose: true,
      confirmButtonText: "保存",
      cancelButtonText: "放弃修改",
      type: "warning"
    })
      .then(() => {
        this.handleSave();
        // this.trueFlag = null;
        this.$emit("getEditFlag", false);
        let number = this.children.findIndex(
          item => to.fullPath.indexOf(item.path) > -1
        );
        if (number == -1) {
          this.$emit("clickLeftMenu", { path: to.fullPath });
        }
        if (!this.nextFlag) {
          this.nextFlag = true;
          next(false);
        } else {
          next();
        }
        // next();
      })
      .catch(action => {
        if (action === "cancel") {
          this.trueFlag = null;
          this.$emit("getEditFlag", false);
          let number = this.children.findIndex(
            item => to.fullPath.indexOf(item.path) > -1
          );
          if (number == -1) {
            this.$emit("clickLeftMenu", { path: to.fullPath });
          }
          next();
        } else {
          //改变上方菜单
          this.$emit("changeRightMenu", { left: 0, right: 1 });
          next(false);
        }
      });
  }
};
</script>

<style lang="scss" scoped>
.member-learning {
  /*如果位置出现了错位的问题,可以加上clear:both;解决*/
  .member-right-inner-bottom {
    clear: both;
    .btn-close-all {
      padding: 5px 5px;
      margin: 5px 20px;
      float: right;
      border-radius: 5px;
      font-size: 16px;
      background-color: #34c5e7;
      color: white;
      border: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/memberData/memberBasic/Learning.vue